export default {
  path: '/regulatory-ordinances',
  component: () =>
    import(
      '@/components/pages/RegulatoryOrdinances/RegulatoryOrdinances.vue'
    )
}
